<script lang="ts">
  let {
    file = $bindable<File | null>(null),
    label = "Anexar arquivo",
    accept = "image/*,application/pdf",
    maxMB = 10,
    hint = "",
  } = $props<{
    file?: File | null;
    label?: string;
    accept?: string;
    maxMB?: number;
    hint?: string;
  }>();

  let drag = $state(false);
  let error = $state<string | null>(null);
  let inputEl: HTMLInputElement | null = $state(null);
  let preview = $state<string | null>(null);

  function setFile(f: File | null) {
    error = null;
    if (preview && preview.startsWith("blob:")) URL.revokeObjectURL(preview);
    preview = null;
    if (!f) { file = null; return; }
    if (f.size > maxMB * 1024 * 1024) { error = `Arquivo passa de ${maxMB} MB`; return; }
    file = f;
    if (f.type.startsWith("image/")) preview = URL.createObjectURL(f);
  }

  function onChange(e: Event) {
    const t = e.target as HTMLInputElement;
    setFile(t.files?.[0] ?? null);
  }

  function onDrop(e: DragEvent) {
    e.preventDefault(); drag = false;
    const f = e.dataTransfer?.files?.[0];
    if (f) setFile(f);
  }

  function clear() {
    setFile(null);
    if (inputEl) inputEl.value = "";
  }

  function fmtSize(b: number): string {
    if (b < 1024) return `${b} B`;
    if (b < 1024 * 1024) return `${(b / 1024).toFixed(1)} KB`;
    return `${(b / 1024 / 1024).toFixed(2)} MB`;
  }
</script>

<div>
  <div class="label">{label}</div>

  {#if file}
    <div class="card flex items-center gap-3">
      {#if preview}
        <img src={preview} alt="" class="w-14 h-14 object-cover rounded border" />
      {:else}
        <div class="w-14 h-14 rounded border flex items-center justify-center text-2xl"
             style="border-color: var(--border)">📄</div>
      {/if}
      <div class="flex-1 min-w-0">
        <div class="font-medium truncate">{file.name}</div>
        <div class="text-xs text-muted">{fmtSize(file.size)} · {file.type || "arquivo"}</div>
      </div>
      <button type="button" class="btn-ghost text-red-600" onclick={clear} aria-label="Remover arquivo">
        Remover
      </button>
    </div>
  {:else}
    <label class="dropzone block" class:is-drag={drag}
           ondragover={(e) => { e.preventDefault(); drag = true; }}
           ondragleave={() => (drag = false)}
           ondrop={onDrop}>
      <input bind:this={inputEl} type="file" {accept} class="sr-only" onchange={onChange} />
      <div class="text-3xl mb-1" aria-hidden="true">📎</div>
      <div class="font-medium">Arraste aqui ou <span class="text-brand underline">escolha um arquivo</span></div>
      <div class="text-xs text-muted mt-1">PDF ou imagem · máx {maxMB} MB</div>
    </label>
  {/if}

  {#if hint}<p class="text-xs text-muted mt-1">{hint}</p>{/if}
  {#if error}<p class="text-xs text-red-600 mt-1">{error}</p>{/if}
</div>
